import React, { useEffect, useState } from 'react';

//import XIcon from './icons/XIcon';

import { InlineShareButtons } from 'sharethis-reactjs';
import { v4 as uuidv4 } from 'uuid';

import {
  EmailShareButton,
  FacebookShareButton,
  FacebookMessengerShareButton,
  LinkedinShareButton,
  RedditShareButton,
  TelegramShareButton,
  TwitterShareButton,
  WhatsappShareButton,
  FacebookIcon,
  FacebookMessengerIcon,
  EmailIcon,
  LinkedinIcon,
  TelegramIcon,
  RedditIcon,
  TwitterIcon,
  WhatsappIcon,
  PinterestShareButton,
  PinterestIcon
} from "react-share";

import log from '../services/log';
import GA from '../services/ga';
import fetcher from '../services/fetcher';
import auth from '../services/auth';
import Darkmode from '../services/darkmode';

import useStyles from '../hooks/useStyles'
import useDarkmode from '../hooks/useDarkmode';

import '../css/share-buttons.css';

function ShareThisButtons(props){
  const [darkmode] = useDarkmode();

  const delay = props.delay;
  const urlRefCode = props.url;

  const bgStyle = {
    fill: Darkmode.get(darkmode).shareButtonsColor
  }

  let startDate = null;
  let endDate = null

  const onShareStart = (source) => {
    startDate = new Date();
    GA.track({
      category: 'Referral',
      action: 'onShareStart',
      label: source
    })
  }
  
  const onShareEnd = (source) => {
    endDate = new Date();
    const seconds = (endDate.getTime() - startDate.getTime())/1000;
    log.traceTag('SHARE_BUTTONS time for sharing', seconds);
    log.traceTag('SHARE_BUTTONS source', source);

    if (seconds > delay || source === 'tw'){
      GA.track({
        category: 'Referral',
        action: 'onShareSuccess',
        label: source
      })
      if (props.onShareSuccess){
        if (source === 'tw'){
          setInterval(() => { 
            props.onShareSuccess(source)
          }, delay*1000);
        } else {
          props.onShareSuccess(source)
        }
      }
    } else {
      GA.track({
        category: 'Referral',
        action: 'onShareCanceled',
        label: source
      })
      if (props.onShareCanceled){
        props.onShareCanceled(source);
      }
    }
  }

  return (
    <>
    {props.title &&
      <>
      {/*<TwitterShareButton className="shareButton" url={urlRefCode} 
        title={props.title}
        hashtags={props.hashtags} 
        via={props.via} 
        beforeOnClick={() => { onShareStart('tw'); }} 
        onShareWindowClose={() => { onShareEnd('tw');}}
      >
        <TwitterIcon size={props.size} round bgStyle={bgStyle}/>
      </TwitterShareButton>
      <span className="mx-1"></span>
      <TelegramShareButton url={urlRefCode} className="shareButton" 
            title={props.title}
            beforeOnClick={() => { onShareStart('telegram'); }} 
            onShareWindowClose={() => { onShareEnd('telegram');}}>
            <TelegramIcon size={props.size} round bgStyle={bgStyle}/>
          </TelegramShareButton>
        <span className="mx-1"></span>
      <FacebookShareButton className="shareButton"  url={urlRefCode} 
                quote={props.title}
                hashtag={'MLStackCafe'}
                beforeOnClick={() => { onShareStart('facebook'); }} 
                onShareWindowClose={() => { onShareEnd('facebook');}}>
        <FacebookIcon size={props.size} round bgStyle={bgStyle}/>
      </FacebookShareButton>
      <span className="mx-1"></span>
      <WhatsappShareButton url={urlRefCode} className="shareButton" 
        title={props.title}
        beforeOnClick={() => { onShareStart('whatsapp'); }} 
        onShareWindowClose={() => { onShareEnd('whatsapp');}}>
        <WhatsappIcon size={props.size} round bgStyle={bgStyle}/>
      </WhatsappShareButton>
      <span className="mx-1"></span>
      <RedditShareButton url={urlRefCode}  className="shareButton" 
      title={props.title}
        beforeOnClick={() => { onShareStart('reddit'); }} 
        onShareWindowClose={() => { onShareEnd('reddit');}}>
        <RedditIcon size={props.size} round bgStyle={bgStyle}/>
      </RedditShareButton>
      <span className="mx-1"></span>
      <PinterestShareButton 
        media={props.media} 
        url={urlRefCode}
        className="shareButton" 
        title={props.title}
        beforeOnClick={() => { onShareStart('pinterest'); }} 
        onShareWindowClose={() => { onShareEnd('pinterest');}}>
        <PinterestIcon size={props.size} round bgStyle={bgStyle}/>
    </PinterestShareButton>*/}
      <InlineShareButtons
          config={{
            property: '660b3ffe648efb001aff119a',
            alignment: 'center',  // alignment of buttons (left, center, right)
            color: 'gray',      // set the color of buttons (social, white)
            enabled: true,        // show/hide buttons (true, false)
            font_size: 16,        // font size for the buttons
            labels: null,        // button labels (cta, counts, null)
            language: 'en',       // which language to use (see LANGUAGES)
            networks: [           // which networks to include (see SHARING NETWORKS)
            'twitter', 'facebook', 'sharethis'
            ],
            padding: 6,          // padding within buttons (INTEGER)
            radius: 30,            // the corner radius on each button (INTEGER)
            show_total: false,
            size: props.size,             // the size of each button (INTEGER)
 
            // OPTIONAL PARAMETERS
            url: props.url, // (defaults to current url)
            image: props.image,  // (defaults to og:image or twitter:image)
            description: props.title,       // (defaults to og:description or twitter:description)
            title: props.title,            // (defaults to og:title or twitter:title)
            message: props.title,     // (only for email sharing)
            subject: '🔥 Check this CryptoWaves ⚠️ Crypto Market Report',  // (only for email sharing)
            username: 'cryptowavesapp' // (only for twitter sharing)
          }}
        />
        <div class='sharethis-sticky-share-buttons' 
          data-url={props.url} 
          data-title={props.title} 
          data-description={props.title} 
          data-message={props.title} 
          data-email-subject={'🔥 Check this CryptoWaves ⚠️ Crypto Market Report'}
          data-image={props.image}
          data-username={'cryptowavesapp'}></div>
    </>
  }
  </>);
};

ShareThisButtons.defaultProps = {
  size: 24,
  title: `Check This Crypto Market RSI Heatmap 🔥 Know What Coins To Buy or Sell Next 🚀 Get Crypto Market RSI 🚨 Alerts On Your Email & Telegram 👇
`,
  //hashtags: ['CryptoAlerts', 'CryptoMarket', 'RSI', 'CryptoTrader'],
  //via: 'CryptoWavesApp',
  image: `https://cryptowaves-app.s3.us-east-2.amazonaws.com/heatmap.png?uuid=${uuidv4()}`,
  url: `https://www.cryptowaves.app/?utm_source=tw&utm_medium=mr_link&utm_campaign=share`,
  short: false,
  refer: false,
  delay: 7,
};

export default ShareThisButtons;

